import React from 'react'

function UnlockRewards({ width = "14", height = "14", classname }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={classname} viewBox="0 0 12.848 14.052">
            <path id="Vector_-_2025-02-14T172027.392" data-name="Vector - 2025-02-14T172027.392" d="M1.506,0A1.507,1.507,0,0,0,0,1.506v1.4A1.807,1.807,0,0,0,.93,4.484L4.4,6.411a3.614,3.614,0,1,0,3.258,0l3.466-1.925a1.807,1.807,0,0,0,.929-1.579v-1.4A1.507,1.507,0,0,0,10.542,0ZM4.819,5.267V1.2h2.41V5.267l-1.2.67ZM8.434,9.638a2.41,2.41,0,1,1-.706-1.7A2.41,2.41,0,0,1,8.434,9.638Z" transform="translate(0.4 0.4)" fill="none" stroke="#fff" strokeWidth="0.8" />
        </svg>
    )
}

export default UnlockRewards